import React from "react";
import { skillGroups } from "../content";
import { useReveal } from "./useReveal";

function Skills() {
  const reveal = useReveal();

  return (
    <section id="skills" className={`section ${reveal.className}`} ref={reveal.ref}>
      <div className="shell">
        <p className="eyebrow">Practice</p>
        <h2>Skills</h2>
        <div className="skill-groups">
          {skillGroups.map((group) => (
            <div key={group.title}>
              <h3>{group.title}</h3>
              <p>{group.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Skills;
